import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";

import ExpressionComposer from "./expression_composer";

export default function CellExpressionDialog({ open, onClose, sheetIndex, cell, fields, onSave }) {
  const handleSave = (expr) => {
    onSave(sheetIndex, cell, expr);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Build Expression for {cell}</DialogTitle>

      <DialogContent>
        <ExpressionComposer fields={fields} onComplete={handleSave} />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
}
